import { Box, Grid2 as Grid, Typography } from '@mui/material';

import React from 'react';
import { UserCounters } from '../types';
import diamond from '../assets/diamond.png';
import gold from '../assets/gold.png';
import ruby from '../assets/ruby.png';
import silver from '../assets/silver.png';

interface UserStatsProps {
  userCounters: UserCounters | null;
  counterError: string | null;
  isMobile: Boolean | null;
  gradientTextStyles: Function;
}

const UserStats: React.FC<UserStatsProps> = ({ userCounters, counterError, isMobile, gradientTextStyles }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography
        variant={isMobile ? 'h6' : 'h4'}
        sx={{ fontFamily: 'Baloo2', fontSize: '32px', fontWeight: '800', letterSpacing: '8px' }}>
        VALUABLES
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, sm: 4, md: 4 }}
        sx={{ justifyContent: 'center', placeItems: 'center', alignItems: 'flex-start' }}
        my={5}>
        {counterError ? (
          <Typography color="error">{counterError}</Typography>
        ) : (
          <>
            {[
              { label: 'Diamond', value: userCounters?.diamond, icon: diamond },
              { label: 'Ruby', value: userCounters?.ruby, icon: ruby },
              { label: 'Gold', value: userCounters?.gold, icon: gold },
              { label: 'Silver', value: userCounters?.silver, icon: silver }
            ].map(({ label, value, icon }, idx) => (
              <Grid
                key={idx}
                size={{ xs: 3, sm: 3, md: 3 }}
                sx={{
                  alignItems: 'center',
                  textAlign: 'center',
                  objectFit: 'contain',
                  placeItems: 'center',
                  margin: '5px 0px'
                }}>
                <img src={icon} alt={label} width={isMobile ? '75%' : 'auto'} height={isMobile ? '75%' : 'auto'} />
                <Typography
                  fontSize={{ xs: '13px', sm: '12px', md: '13.52px' }}
                  fontFamily="Baloo2"
                  fontWeight={800}
                  lineHeight={{ xs: '16px', md: '23.04px' }}
                  margin={{ sm: '0px', md: '3px' }}
                  padding={{ sm: '0px', md: '3px' }}>
                  {label}
                </Typography>
                <Typography
                  fontSize={{ xs: '13px', sm: '12px', md: '13.52px' }}
                  fontFamily="Baloo2"
                  fontWeight={500}
                  lineHeight={{ xs: '16px', md: '23.04px' }}>
                  {value}
                </Typography>
              </Grid>
            ))}
          </>
        )}
      </Grid>
    </Box>
  );
};

export default UserStats;
